<template>
    <div>
        <Row :style="{display:isNextSearchDisp?'block':'none'}">
            <div style="float: left;padding-left: 5px;width:380px;"><Input v-model="text" :maxlength="searchTextMaxlength" search enter-button="查询" @on-search="nextSearch" :placeholder="isRegulations?'当前区域适用法规查询':'请输入查询内容'" /></div>
            <div style="padding-left: 5px;float: left;" :style="{display:isShowPaperWord?'inline-block':'none'}">
                <Select v-model="modelPaperWord" :style="{width:isTaxCase?'220px':'120px'}" placeholder="全部分类" @on-select="onPaperWordSelect">
                    <Option v-for="item in paperWordList" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div style="padding-left: 5px;float: left;" :style="{display:isShowLayer?'inline-block':'none'}">
                <Select v-model="modelCourtLayer" :style="{width:isTaxCase?'220px':'120px'}" placeholder="法院层级" @on-select="onLayerSelect">
                    <Option v-for="item in courtLayer" :value="item.value" :key="item.value">{{ item.label }}</Option>
                </Select>
            </div>
            <div style="padding-left: 5px;float: left;" :style="{display:isShowSearchBox?'inline-block':'none'}">
                <Select v-model="courtValue" filterable clearable :remote-method="remoteMethod1" placeholder="选择或输入法院" style="width:200px" :loading="loading1" @on-clear="clearOption" @on-query-change="txtchange" @on-select="onRemotSelect">
                    <Option v-for="(option, index) in options1" :value="option.value" :key="index">{{option.label}}</Option>
                </Select>
            </div>
            <div style="float: left;" :style="{display:isShowDateBoard?'inline-block':'none'}">
                <DatePicker type="daterange" split-panels confirm format="yyyy-MM-dd" placement="bottom-end" style="padding-left: 5px;" placeholder="请选择时间范围" :editable="false" v-model="timeZone" @on-ok="onOK" @on-clear="onClear" @on-change="timeOnChange"></DatePicker>
            </div>
        </Row>
        <div :style="{display:isNextSearchDisp?'block':'none',height:'5px',lineHeight:'5px'}" />
    </div>
</template>
<script>
import store from '../../../store/'
import More from "../../../api/common/more.js"
import axios from 'axios'
let MoreFun = new More()
export default {
    name: 'NextSearchBar',
    props: {
        isHidden: Boolean, //默认是否显示
        isShowLayer: {
            type: Boolean,
            default: true, //是否显示法院层级
        },
        isShowSearchBox: {
            type: Boolean,
            default: true, //是否显示法院查询输入框
        },
        isTaxCase: {
            type: Boolean,
            default: false,
        },
        isShowPaperWord:{
            type:Boolean,
            default:false,
        },
        isShowDateBoard:{
            type:Boolean,
            default:true,
        }
    },
    data() {
        return {
            caseid:'000000',           //税务案例分类
            modelCourtLayer: 0, //法院层级
            modelPaperWord:'000998',   ////全部判例分类
            paperWordList:[],
            courtLayer: [{
                value: 0,
                label: '全部法院'
            }, {
                value: 1,
                label: '最高法院'
            }, {
                value: 2,
                label: '高级法院'
            }, {
                value: 3,
                label: '中级法院'
            }, {
                value: 4,
                label: '基层法院'
            }],
            // 虚开发票 偷税（逃）税 骗税（骗取出口退税）骗取留抵退税 伪造发票（制售假发票）滥用税收协定 其它
            list2: [{
                value: 0,
                label: '全部分类'
            }, {
                value: 1,
                label: '虚开发票'
            }, {
                value: 2,
                label: '偷税（逃）税'
            }],
            isNextSearchDisp: this.isHidden,
            timeZone: ["", ""],
            text: "",
            searchTextMaxlength: 100,
            isRegulations: this.$router.history.current.name === 'localindex' ? true : false,

            courtValue: '',
            options1: [],
            loading1: false,
            list: []
            //data3: ['中华人民共和国最高人民法院', '北京市门头沟区人民法院', '四川省成都高新技术产业开发区人民法院','重庆市第一中级人民法院','重庆市第二中级人民法院','河南省郑州市中级人民法院','河南省南阳市中级人民法院','内蒙古自治区锡林郭勒盟中级人民法院']
        }
    },
    computed: {},
    mounted() {
        //console.log('router333===>',this.$router.history.current.name)
    },
    created() {
        this.getPaperWordList()
        this.getList()
        // this.loadDropList()
        this.nextSearch()
        //console.log("isNextSearchDisp:"+this.isNextSearchDisp)
        //console.log('nextsearchbar3====>')
    },
    methods: {
        // filterMethod(value, option) {
        //     return option.toUpperCase().indexOf(value.toUpperCase()) !== -1;
        // },
        getPaperWordList() {
            this.paperWordList=store.state.user.initData.paperword
            this.modelPaperWord='000998'//全部判例分类
        },
        getList() {
            if (this.isTaxCase) {
                // axios.get('./test.json').then((result) => {
                //     this.courtLayer = result.data.list_tax_case
                // })
                this.courtLayer=store.state.user.initData.taxCaseCategory
                this.modelCourtLayer='000000'
            }
        },
        loadDropList() {
            if (this.isTaxCase) {
                this.courtLayer = []
                this.courtLayer = this.list2
            }
        },
        onLayerSelect(value) {
            console.log(value)
            if(this.isTaxCase){
                this.caseid=value.value
                this.modelCourtLayer = value.value
            }else{
                this.modelCourtLayer = value.value
            }
            
            this.nextSearch()
        },
        onPaperWordSelect(value) {
            console.log(value)
            this.modelPaperWord = value.value
            this.nextSearch()
        },
        onRemotSelect(value) {
            this.courtValue = value.label
            this.nextSearch()
        },
        txtchange(value) {
            console.log('txtchange==>' + value)
            if (value === '') {
                this.options1 = []
            }
            //this.courtValue = value
        },
        clearOption() {
            this.options1 = []
            this.nextSearch()
        },
        remoteMethod1(query) {
            if (query !== '') {
                this.loading1 = true;
                setTimeout(() => {
                    this.loading1 = false;
                    //console.log(store.state.user.initData.court)
                    //console.log(this.modelCourtLayer)
                    var temp = []
                    if (this.modelCourtLayer === 0) {
                        temp = store.state.user.initData.court
                    } else {
                        temp = store.state.user.initData.court.filter(p => p.type == this.modelCourtLayer)
                    }
                    // console.log("temp===>")
                    // console.log(temp)
                    this.list = Array.from(temp, (x) => x.name)
                    console.log('remoteMethod1==>')
                    // console.log(this.list)
                    // console.log(store.state.user.initData.court)
                    const list = this.list.map(item => {
                        return {
                            value: item,
                            label: item
                        };
                    });
                    this.options1 = list.filter(item => item.label.indexOf(query) > -1);
                }, 200);
            } else {
                this.options1 = [];
            }
        },
        timeOnChange() {
            console.log('timeonchange==>')
            var time = []
            if (this.timeZone[0] !== "") {
                time[0] = MoreFun.getFormattedDate(this.timeZone[0])
                time[1] = MoreFun.getFormattedDate(this.timeZone[1])
                this.timeZone = time
                //this.$emit("on-time-change",this.timeZone)
                //this.nextSearch()
            } else {

            }
        },
        onOK() {
            console.log('onOK-==>')
            this.nextSearch()
        },
        onClear() {
            console.log('onClear-==>')
            this.timeZone = []
            this.nextSearch()
        },
        nextSearch() {
            let searchCondition = {}
            searchCondition.time = this.timeZone
            searchCondition.text = this.text
            searchCondition.court = this.courtValue
            searchCondition.courttype = this.modelCourtLayer
            searchCondition.paperword = this.modelPaperWord
            searchCondition.caseid=this.caseid
            // console.log('emit-nextsearch==>')
            // console.log(searchCondition)
            this.$emit('next-search', searchCondition)
        },
        display(isShow) {
            this.isNextSearchDisp = isShow
        },
        resetCondition() {
            this.timeZone = []
            this.text = ""
        },
        getNextCondition() {
            let searchCondition = {}
            searchCondition.time = this.timeZone
            searchCondition.text = this.text
            return searchCondition
        },
    }
}
</script>
<style scoped>
</style>